import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4aa19d54"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "case_study_hero" };
const _hoisted_2 = { class: "container inner" };
const _hoisted_3 = { class: "case_study_hero__content" };
const _hoisted_4 = {
    key: 0,
    class: "text-primary"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "case_study_hero__deliverables" };
const _hoisted_8 = { class: "deliverables" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'case_study_hero',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_badge = _resolveComponent("badge");
            const _component_smart_text = _resolveComponent("smart-text");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_badge, {
                            content: __props.d.services.map(category => category),
                            hasGlimmer: "true",
                            small: "true"
                        }, null, 8, ["content"]),
                        _createVNode(_component_smart_text, null, {
                            default: _withCtx(() => [
                                (__props.d.client_title)
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
                                        _createElementVNode("a", {
                                            class: "no-style",
                                            href: __props.d.client_alias
                                        }, _toDisplayString(__props.d.client_title), 9, _hoisted_5)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        (__props.d.question)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.d.question), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.deliverables, (item) => {
                                    return (_openBlock(), _createElementBlock("span", null, _toDisplayString(item), 1));
                                }), 256))
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
